<template>
    <section class="payment__form">
        <template v-if="
            state.currentView == 'FAWRYPAY_INIT_VIEW' && 
                state.processing != true
        ">
            <form @submit.prevent="checkDetails">
                <p class="container__col-md-12 container__col-sm-12 payment__instruction headline">
                    {{ $t("fawrypay.init.instruction")}}
                </p>

                <PrimaryInput
                    :title="$t('fawrypay.input.phone')"
                    type="tel"
                    inputName="phone"
                    placeholder="07086493069"
                    prefix-image="smart-phone"
                    @value-change="collectPhoneNumber"
                    :number-only="true"
                    :defaultValue="
                        getValueFromPath(state, 'inputs.phone.value')
                    "
                    :isRequired="
                        getValueFromPath(state, 'inputs.phone.required') || true
                    "
                />

                <PrimaryButton 
                    :disabled="!hasCompletedFields"
                    type="submit"
                    :content="
                        [
                            $t('ui.pay.btn'),
                            state.currency,
                            state.amount.toLocaleString()
                        ]
                            .filter(Boolean)
                            .join(' ')
                    "
                />
            </form>
        </template>

        <template  v-if="state.currentView == 'FAWRYPAY_CONFIRM_VIEW' && state.processing != true">
            <!-- After the pay button has been clicked -->
            <div>
                <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                    {{ $t("fawrypay.steps.instruction") }}
                </p>

                <div class="reference">
                    <p class="reference__code">
                        {{ $t("fawrypay.steps.reference")}} {{ getValueFromPath(state, 'reference') }}
                    </p>
                </div>

                <!-- Steps -->
                <div class="container--row steps">
                    <div class="container__col-md-2 container__col-sm-2">
                        <p class="steps__heading">
                            {{$t("fawrypay.steps.number")}} 1
                        </p>
                    </div>
                    <div class="container__col-md-10 container__col-sm-10">
                        <p class="steps__detail">
                            {{$t("fawrypay.steps.one")}}
                        </p>
                    </div>
                </div>

                <div class="container--row steps__second">
                    <div class="container__col-md-2 container__col-sm-2">
                        <p class="steps__heading">
                            {{$t("fawrypay.steps.number")}} 2
                        </p>
                    </div>
                    <div class="container__col-md-10 container__col-sm-10">
                        <p class="steps__detail">
                            {{$t("fawrypay.steps.two")}}
                        </p>
                    </div>
                </div>
            </div>
        </template>
    </section>
</template>

<script>
import { ref, onBeforeUnmount, computed } from "vue";
import { injectStore, mapState } from "redux-vuex";
import { getValueFromPath } from "@/support/helpers";
import PrimaryInput from "@/components/form/base-input";
import PrimaryButton from "@/components/form/base-button.vue";

export default {
    name: "FawryPay",
    components: {
        PrimaryInput,
        PrimaryButton,
    },

    setup() {
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const phone = ref("");

        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }

        const hasCompletedFields = computed(() => {
            return phone.value !== "";
        });

        function checkDetails() {
            if (hasCompletedFields.value) {
                Next();
            }
        }

        function collectPhoneNumber(e) {
            phone.value = e;
            const data = {
                phone: phone.value,
            };

            checkoutData.value.view.context.$actions.update(data);
        }


        onBeforeUnmount(() => {
            subscription();
        });
        
        
        return {
            state: mapState({
                amount: (state) => getValueFromPath(state, "amount") || null,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
                processing: (state) => getValueFromPath(state, "processing") || false,
                inputs: (state) => getValueFromPath(state, "view.context.inputs") || {},
                reference: (state) => getValueFromPath(state, "view.context.reference") || null,
            }),
            Next,
            subscription,
            hasCompletedFields,
            checkDetails,
            collectPhoneNumber,
            getValueFromPath,
        };
    },

};
</script>

<style lang="scss" scoped>
    .headline {
        margin-top: 32px;
    }

    .reference {
        margin-bottom: 48px;

        &__code {
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 15px;
            text-align: center;
            color: #000000;
        }
    }

    .steps {
        margin-bottom: 30px;

        &__heading {
            font-style: normal;
            font-weight: 700;
            font-size: 14px;
            line-height: 14px;
            letter-spacing: 0.3px;
            color: #000000;
        }

        &__detail {
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 14px;
            color: #656565;
        }

        &__second {
            margin-bottom: 0;
        }
    }

</style>